module.exports = __webpack_public_path__ + "img/bg_top.68f6c691.jpg";